// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mocked-events-banner__image.small[data-v-030d4ab9]{width:320px;height:250px}.mocked-events-banner__image.large[data-v-030d4ab9]{width:100%}", ""]);
// Exports
module.exports = exports;
